/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Card } from 'components/card'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Link } from '@ta-interaktiv/contentbricks'

// TODO Set the correct article ID here
const ARTICLE_ID = '15087585'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical very fitted segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              Der Corona-Index
              <div className='sub header'>
                Weniger Autos, mehr Leute vor dem TV und die Börse auf Talfahrt?
                Diese Indikatoren zeigen in Echtzeit, wie das Virus unser Leben
                verändert.
              </div>
            </div>
          </h1>
          <p className='ta author'>
            Patrick Meier, Sven Cornehls, Simone Luchetta, Mathias Born, Markus
            Diem
          </p>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui container'>
        <div className='update'>
        <span>Nicht mehr alle Daten werden weiter aktualisiert. Das Nachfolgeprojekt ist hier zu finden: <b><a href="https://www.tagesanzeiger.ch/so-veraendert-corona-unser-leben-994908551398" target="_blank"><i className='icon external-link'></i>So verändert Corona unser Leben</a></b></span>
        </div>
          <div className='ui three doubling stackable cards'>
            {/* <div className='ui three column row'> */}
            <Card
              titel='Auslastung der Stadtberner Parkhäuser'
              iframe='https://datawrapper.dwcdn.net/pIWM2/'
              id='parking'
            />
            <Card
              titel='Internetverkehr'
              iframe='https://datawrapper.dwcdn.net/XV0fB/'
              id='internet'
            />
            <Card
              titel='Strassenauslastung'
              iframe='https://datawrapper.dwcdn.net/lGFT0/'
              id='commute'
            />
            <Card
              titel='Verabredungen'
              iframe='https://datawrapper.dwcdn.net/TOu8V/'
              id='doodle'
            />
            <Card
              titel='Mobilität'
              iframe='https://datawrapper.dwcdn.net/ztFlf/'
              id='mobile'
            />
            <Card
              titel='SRF-Zuschauerzahlen'
              iframe='https://datawrapper.dwcdn.net/3LMi5/'
              id='srf'
            />
            <Card
              titel='Flughafen Zürich'
              iframe='https://datawrapper.dwcdn.net/umQBh/'
              id='airtraffic'
            />
            <Card
              titel='Autos in Zürich'
              iframe='https://datawrapper.dwcdn.net/4b8ty/'
              id='cars'
            />
            <Card
              titel='Börse'
              iframe='https://datawrapper.dwcdn.net/I0fW7/'
              id='stock'
            />
            <Card
              titel='Euro'
              iframe='https://datawrapper.dwcdn.net/NfHfa/'
              id='eur'
            />
            <Card
              titel='Bitcoin'
              iframe='https://datawrapper.dwcdn.net/5svVw/'
              id='bitcoin'
            />
            <Card
              titel='Gold'
              iframe='https://datawrapper.dwcdn.net/Y09oP/'
              id='gold'
            />
            <Card
              titel='Öl'
              iframe='https://datawrapper.dwcdn.net/5mSPx/'
              id='oil'
            />

            {/* </div> */}
          </div>
          {/* <p>
          <div className='subscript'>
            <span>① 28. Februar 2020: Bundesrat erklärt «besondere Lage»; Grossverantaltungen über 1000 Pers. werden verboten.</span><br /><span>② 13. März 2020: Schulen schliessen; Veranstaltung mit mehr als 100 Personen werden verboten.</span><br /><span>③ 16. März 2020: Bundesrat erklärt die «ausserordentliche Lage»</span><br /><span>20. März 2020: Versammlungen von mehr als 5 Pers. werden verboten</span>
            </div>
          </p> */}
        </div>
      </div>

      <div className='ui vertical segment' id='parking_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Parkplätze in Bern</b>
          </h3>
          <p>
            Der Lockdown hat grosse Auswirkungen auf das Alltagsleben
            insbesondere in den Städten: Die meisten Geschäfte sowie die
            Restaurants, Cafés und Bars mussten schliessen. Fast alle
            Veranstaltungen wurden abgesagt. Und wer kann, arbeitet aus dem
            heimischen Büro.{' '}
            <strong>Entsprechend sind viele Innenstädte verwaist.</strong>{' '}
            Besucher von ausserhalb kommen wenige. Die Autos, die normalerweise
            etwa während eines Einkaufsbummels, einem Treffen oder einer
            Veranstaltung in einem der Parkhäuser zurückgelassen werden, stehen
            nun auf dem Parkplatz vor dem Haus. Deshalb sind auch die Parkhäuser
            weniger stark belegt, wie das Beispiel aus Bern zeigt.
          </p>
          <p>
            <a href='#parking'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          <div className='box'>
            <p>
              Die Daten werden halbstündlich von{' '}
              <Link allowWordWrap href='http://parking-bern.ch/d/index.php'>
                parking-bern.ch
              </Link>{' '}
              ausgelesen. Für jeden Tag wird der Auslastungsmittelwert über alle
              Parkhäuser gebildet.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' id='internet_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Internetverkehr</b>
          </h3>
          <p>
            Je mehr der Verkehr auf den Strassen zum Erliegen kommt, desto mehr
            ist auf der Daten-Autobahn los: Videokonferenzen, Fern-Unterricht
            und Serien-Gucken à gogo, dazu Gaming-Nächte, das Arbeiten im
            Homeoffice und eine Flut von Corona-News und -Witzen. Halten die
            Internet-Leitungen das aus? «Wir sehen 30 Prozent Mehrverkehr seit
            dem Lockdown, das findet aber problemlos in den Kapazitätsreserven
            Platz», sagt Christian Wittenhorst, Chef von SwissIX, dem grössten
            Internet Exchange Dienst in der Schweiz. Der Verein stellt die
            Infrastruktur für den Austausch der Datenpakete zwischen den Netzen
            der einzelnen Internet-Provider bereit.
          </p>
          <p>
            Die ständig aktualisierten Daten von SwissIX zeigen, dass am
            Sonntag, 29. März 2020 ein vorläufiger Peak erreicht wurde: 17 000
            Terabit sausten an diesem Tag durch seine Server. Der Datenwust
            stieg aber bereits eine Woche vor dem Lockdown vom Montag, 16. März,
            sprunghaft und nachhaltig an. «Damals hat ein grosser
            Streaming-Anbieter einen Teil seines Verkehrs über uns umgeleitet»,
            erklärt Wittenhorst. Der tägliche Spitzen-Verkehr am Abend sei
            deshalb zwischenzeitlich wegen Video-Streaming und Gaming merklich
            erhöht gewesen, habe sich inzwischen aber wieder bei den
            Vor-Corona-Werten eingependelt. Dies dürfte primär eine Folge der
            Reduktion der Streaming-Bandbreiten von Netflix und anderen sein und
            heisst nicht unbedingt, dass Schweizerinnen und Schweizer weniger
            Serien schauen.
          </p>
          <p>
            Auch das strahlende Frühlingswetter hat viele Menschen ins Freie
            gelockt, so dass am letzten April-Wochenende so wenig auf den
            SwissIX-Leitungen los war wie seit dem Lockdown nicht mehr. (luc)
          </p>
          <p>
            Deutliche Veränderungen sind indes im täglichen Verlauf erkennbar:
            «Wir haben mehr und gleichmässig hohen Verkehr während der
            Arbeitszeiten. Und wir sehen, wann die Schweizer Mittagspause
            machen.» Das sei vor Corona nicht sichtbar gewesen: «Ein
            wesentlicher Teil des firmeninternen Verkehrs wurde schweizweit also
            ins Internet verschoben.» Das Arbeiten zu Hause belastet das Netz
            aber nicht annähernd so stark wie das Streaming am Abend.
          </p>
          <div style={{ margin: '30px 0 10px 0' }}>
            <b>Tagesverlauf Internetverkehr</b>
            <AutofitIFrame src='https://datawrapper.dwcdn.net/nGjWC/' />
          </div>
          <p>
            <strong>Lesen sie auch:</strong>{' '}
            <Link
              allowWordWrap
              href='https://www.tagesanzeiger.ch/so-stark-hat-der-onlineverkehr-seit-ausbruch-der-corona-krise-zugelegt-436727633329'
            >
              So stark hat der Onlineverkehr seit Ausbruch der Corona-Krise
              zugelegt
            </Link>
          </p>
          <p>
            <a href='#internet'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          {/* <div className='box'>
            <p>
              Methodentext hier.
            </p>
          </div> */}
        </div>
      </div>

      <div className='ui vertical segment' id='commute_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Strassenauslastung</b>
          </h3>
          <p>
            Bis zum 13. März herrschte auf den Schweizer Autobahnen noch
            «courant normal».{' '}
            <strong>
              Doch als der Bundesrat an jenem Tag die Schliessung der Schulen
              verordnete, brach auch der Verkehr zusammen.
            </strong>{' '}
            Wie markant das Aufkommen zurückging, zeigt eine Datenanalyse dieser
            Zeitung. Über automatisierte Anfragen bei Google Maps lässt sich
            rekonstruieren, wie sich die Reisezeit für eine bestimmte
            Autobahn-Strecke verändert. Berücksichtigt sind in der Analyse die
            Stosszeiten morgens und abends. Bei den Daten von Google handelt es
            sich um Prognosewerte, welche die aktuelle Verkehrssituation
            berücksichtigen. Ein Beispiel: Für die Strecke von Bern nach Zürich
            brauchten Autopendler am 11. März noch eine Stunde und 45 Minuten.
            Am 25. März hatte sich die Reisezeit bereits um rund zehn Minuten
            verkürzt. Ähnlich sind die Zeitgewinne für den Rückweg. Die Frage
            ist: Bleibt das Verkehrsaufkommen auch dann noch tief, wenn die
            Massnahmen des Bundesrats gelockert werden? Und wie schnell wird
            sich der Verkehr erholen?
          </p>
          <p>
            <strong>Lesen sie auch:</strong>{' '}
            <Link
              allowWordWrap
              href='https://www.tagesanzeiger.ch/verkehr-auf-autobahnen-bricht-um-ein-drittel-ein-822910488837'
            >
              Verkehr auf Autobahnen bricht um ein Drittel ein
            </Link>
          </p>
          <p>
            <a href='#commute'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          {/* <div className='box'>
            <p>
              Die Handy-Tracking-Daten stammen aus einer Studie, die das
              statistische Amt des Kantons Zürich und die ETH Zürich in Auftrag
              gegeben haben. Die Daten umfassen die ganze Schweiz, und sie sind
              repräsentativ. Im Fokus stehen die täglich zurückgelegten
              Distanzen sowie die Bewegungsradien. Die{' '}
              <Link href='https://statistik.zh.ch/internet/justiz_inneres/statistik/de/aktuell/mitteilungen/2020/covid_mobilitaetsverhalten.html'>
                Daten
              </Link>{' '}
              werden täglich aktualisiert.
            </p>
          </div> */}
        </div>
      </div>

      <div className='ui vertical segment' id='doodle_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Verabredungen</b>
          </h3>
          <p>
            In der Corona-Krise, der Zeit des «Bleibt zu Hause», waren reale
            Sitzungen oder Abmachungen im Freundeskreis rar. Das belegt auch die
            Statistik von Doodle, dem Online-Dienst zur Terminvereinbarung, der
            wie Tamedia zur TX Group gehört.{' '}
            <strong>
              Die Zahl der Doodles ging in der Schweiz um den Lockdown herum im
              März schlagartig um 50 bis 60 Prozent zurück.
            </strong>{' '}
            Der Tiefpunkt wurde am 12. April erreicht mit einem Rückgang von
            über 80 Prozent. Seither geht’s in der Tendenz wieder aufwärts –
            dank Lockerungen in der Schule, weniger Home-Office und der
            Möglichkeit, in kleinen Gruppen eine Bar oder ein Restaurant zu
            besuchen. Einen Ausreisser gibt es am 21. Mai: Auffahrt! Ein Feier-
            und Familientag, mit wenig Terminen.
          </p>
          <p>
            <a href='#doodle'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          <div className='box'>
            <p>
              <Link allowWordWrap href='https://doodle.com/de/'>
                Doodle
              </Link>{' '}
              zählt die Doodles pro Tag, bei denen bei ihrer Erstellung die
              Zeitzone «Europe/Zurich» lautet. Das kommt entweder aus den
              Browsereinstellungen der Nutzer oder aus ihrem Doodle-Account.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' id='mobile_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Mobilität in der Schweiz</b>
          </h3>
          <p>
            Wie gut befolgen die Schweizerinnen und Schweizer die Weisungen des
            Bundesrats? Halten sie sich an die Vorgaben des Social Distancing?
            Und bleiben Sie zu Hause, wie das Bundesamt für Gesundheit (BAG)
            empfiehlt? Die Handy-Bewegungsdaten von 2500 Freiwilligen im Alter
            zwischen 15 und 79 Jahren geben Aufschluss darüber. Die Daten
            zeigen, dass sich die Menschen anfangs gut an die Vorgaben des
            Bundesrats gehalten haben -{' '}
            <strong>
              die zurückgelegten Distanzen gingen deutlich zurück.
            </strong>{' '}
            Doch bleibt die Disziplin bestehen? Und was passiert, wenn es
            draussen schön ist? Und wie sieht es aus, wenn die Krise länger
            dauert?
          </p>
          <p>
            <strong>Lesen sie auch:</strong>{' '}
          </p>
          <p>
            <Link
              allowWordWrap
              href='https://www.tagesanzeiger.ch/handydaten-zeigen-die-jungen-bewegen-sich-wieder-mehr-936450161451'
            >
              Handydaten zeigen: Die Jungen bewegen sich wieder mehr
            </Link>
          </p>
          <p>
            <Link
              allowWordWrap
              href='https://www.tagesanzeiger.ch/handydaten-zeigen-die-jungen-bewegen-sich-nicht-am-meisten-119798074647'
            >
              Handydaten zeigen: Die Leute zieht es nach draussen
            </Link>
          </p>
          <p>
            <a href='#mobile'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          <div className='box'>
            <p>
              Die Handy-Tracking-Daten stammen aus einer Studie, die das
              statistische Amt des Kantons Zürich und die ETH Zürich in Auftrag
              gegeben haben. Die Daten umfassen die ganze Schweiz, und sie sind
              repräsentativ. Im Fokus stehen die täglich zurückgelegten
              Distanzen sowie die Bewegungsradien. Die{' '}
              <Link href='https://statistik.zh.ch/internet/justiz_inneres/statistik/de/aktuell/mitteilungen/2020/covid_mobilitaetsverhalten.html'>
                Daten
              </Link>{' '}
              werden täglich aktualisiert.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' id='srf_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>SRF-Zuschauerzahlen</b>
          </h3>
          <p>
            Was tun, wenn man nicht arbeiten darf und zu Hause ausharren muss?
            Dann schaltet man den Fernseher ein. Doch stimmt das wirklich? Die
            Publikumszahlen von SRF geben Aufschluss. Tatsächlich zeigt die
            Kurve stark nach oben, seit der Bundesrat die Bürgerinnen und Bürger
            aufgefordert hat, möglichst zu Hause zu bleiben. Besonders hohe
            Einschaltquoten haben in den Krisenzeiten erwartungsgemäss
            Nachrichtensendungen wie die «Tagesschau» und «10 vor 10».
            Mittlerweile hat SRF auch das Tagesangebot stark ausgebaut –
            insbesondere mit Lernsendungen für die Schulkinder.
          </p>
          <p>
            <a href='#srf'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          <div className='box'>
            <p>
              Die Publikumszahlen werden von Mediapulse in ausgewählten
              Testhaushalten erhoben und auf die Gesamtbevölkerung
              hochgerechnet. SRF stellt die Zahlen auf der{' '}
              <Link href='https://medien.srf.ch/publikumszahlen'>Website</Link>{' '}
              zur Verfügung – allerdings nur für SRF 1 und SRF 2 und teilweise
              mit mehreren Tagen Verspätung. Nach einer Woche verschwinden die
              Dokumente wieder. Für diese Grafik werden die PDFs automatisiert
              ausgelesen und aufbereitet. Aus den durchschnittlichen
              Zuschauerzahlen pro Sendung wird über Tag der Mittelwert gebildet.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' id='airtraffic_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Luftverkehr</b>
            <small />
          </h3>
          <p>
            Im Luftverkehr zeigten sich früh die ersten Auswirkungen des
            Coronavirus. Bereits Ende Januar stellten erste Fluggesellschaften
            ihre Flüge nach China ein – dem Land, das als erstes vom Virus
            heimgesucht wurde. Auch die Swiss reagierte und reduzierte erst
            ihren Betrieb, dann{' '}
            <Link
              allowWordWrap
              href='https://www.srf.ch/news/schweiz/mit-ausnahme-von-hongkong-swiss-fliegt-bis-ende-maerz-nicht-mehr-nach-china'
            >
              strich die Fluggesellschaft am 14. Februar 2020 alle Linien von
              und nach China.
            </Link>{' '}
            Die Verunsicherung der Flugpassagiere am Flughafen Zürich zeigte
            sich aber besonders nach dem 28. Februar. An jenem Tag verkündete
            der Bundesrat das Verbot aller Grossveranstaltungen mit mehr als
            1000 Personen. Seither sprachen mehrere Länder Reiseverbote aus.{' '}
            <strong>
              Die Zahl der Starts und Landungen am Flughafen Zürich geht seither
              rasant zurück.
            </strong>{' '}
            Auch die jüngeren Zahlen zum globalen Flugverkehr zeigen eine
            drastische Abnahme. Der Trend dürfte sich fortsetzen.{' '}
            <strong>
              Mit jedem weiteren gestrichenen Flug steigt der wirtschaftliche
              Druck auf die Fluggesellschaften.
            </strong>{' '}
            Währende erste Airlines{' '}
            <Link
              allowWordWrap
              href='https://www.tagesanzeiger.ch/wirtschaft/unternehmen-und-konjunktur/billigairline-flybe-meldet-insolvenz-an/story/30135914'
            >
              bereits Konkurs angemeldet haben
            </Link>
            , rufen andere immer lauter{' '}
            <Link
              allowWordWrap
              href='https://www.tagesanzeiger.ch/wissen/coronavirus/alitalia-steht-vor-der-pleite-italien-plant-uebernahme/story/26096476'
            >
              nach Staatshilfe.
            </Link>
          </p>
          <p>
            <a href='#airtraffic'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          <div className='box'>
            <p>
              Die Daten zu den Starts und Landungen stammen aus der{' '}
              <Link href='https://www.flughafen-zuerich.ch/unternehmen/laerm-politik-und-umwelt/flugbewegungen/bewegungsstatistik'>
                Bewegungsstatistik des Flughafens Zürich
              </Link>
              . Diejenigen zu den aktuellen globalen Flugbewegungen werden
              stündlich von{' '}
              <Link allowWordWrap href='https://www.flightradar24.com'>
                Flightradar24
              </Link>{' '}
              ausgelesen.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' id='cars_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Autos in Zürich</b>
          </h3>
          <p>
            Wenn die Menschen daheim bleiben müssen, wenn sie zu Hause oder gar
            nicht mehr arbeiten dürfen, wenn die Leute zu Fuss gehen – dann
            wirkt sich das auf das Verkehrsaufkommen aus. Statt Autolärm hören
            wir Vögel pfeifen, der Verkehr scheint zuweilen stillzustehen. Doch
            trifft diese Annahme auch zu? Die Zahlen aus der Stadt Zürich geben
            Aufschluss darüber. Es ist davon auszugehen, dass die Corona-Krise
            die Zahl der Autos auf den Strassen deutlich reduzieren wird.
            Andererseits steigen viele Leute, die normalerweise den öffentlichen
            Verkehr benutzen, auf Privatwagen um. Und es sind weit mehr Kuriere
            als normalerweise unterwegs.
          </p>
          <p>
            <a href='#cars'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          <div className='box'>
            <p>
              Die Stadt Zürich misst an 94 Stellen die Zahl der Autos
              (motorisierter Individualverkehr), die vorbeifahren. Die{' '}
              <Link href='https://data.stadt-zuerich.ch/dataset/sid_dav_verkehrszaehlung_miv_od2031'>
                Werte
              </Link>{' '}
              werden stündlich erfasst und täglich geliefert.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' id='stock_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Börse</b>
          </h3>
          <p>
            Die Börsenkurse brechen vielerorts seit Ende Februar stark ein. Das
            zeigt: Die Marktteilnehmer machen sich grosse Sorgen um die
            wirtschaftlichen Folgen der Corona-Krise. Auffällig ist, dass die
            Kurse noch von Höchstkurs zu Höchstkurs eilten, als das Virus erst
            in China grassierte. Aber{' '}
            <strong>
              die rasche Verbreitung des Virus auf der übrigen Welt hat die
              Börsenwelt schockiert.
            </strong>{' '}
            Wie es an den Finanzmärkten weitergeht, hängt davon ab, ob die
            Ausbreitung des Virus gestoppt werden kann. Stabilisieren werden
            sich die Kurse erst, wenn die Marktteilnehmer davon überzeugt sind,
            dass die Regierungen und Notenbanken die richtigen Massnahmen zur
            Eindämmung der Pandemie und zum Abfedern der wirtschaftlichen
            Schäden ergriffen haben.
          </p>
          <div style={{ margin: '30px 0 10px 0' }}>
            <b>Langfristige Entwicklung an der Börse</b>
            <AutofitIFrame src='https://datawrapper.dwcdn.net/d2GlJ/' />
          </div>
          <p>
            <a href='#stock'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          <div className='box'>
            <p>
              <ul>
                <li>
                  Der <strong>Swiss-Performace-Index (SPI)</strong> umfasst
                  nahezu alle kotierten schweizerischen Aktiengesellschaften. Er
                  gilt als Gesamtmarktindex für den schweizerischen Aktienmarkt.
                  Hier verwenden wir den reinen Preisindex, ohne
                  Berücksichtigung der Dividenden. Quelle:{' '}
                  <Link href='https://www.six-group.com/exchanges/indices/data_centre/shares/spi_family_de.html'>
                    SIX Swiss Exchange
                  </Link>
                </li>
                <li>
                  Der <strong>Euro Stoxx 50</strong> ist ein Aktienindex der
                  sich aus 50 grossen, börsennotierten Unternehmen des
                  Euro-Währungsgebiets zusammensetzt. Er gilt als der führende
                  Böresenindex Europas. Quelle:{' '}
                  <Link href='https://finance.yahoo.com/quote/%5ESTOXX50E'>
                    Yahoo Finance
                  </Link>
                </li>
                <li>
                  Der <strong>Standard & Poor’s 500 (S&P 500)</strong> ist ein
                  Aktienindex, der die Aktien von 500 der größten
                  börsennotierten US-amerikanischen Unternehmen umfasst. Er ist
                  gehört zu den meistbeachteten Aktienindizes der Welt. Quelle:{' '}
                  <Link href='https://finance.yahoo.com/quote/%5EGSPC?p=^GSPC'>
                    Yahoo Finance
                  </Link>
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' id='eur_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Euro</b>
          </h3>
          <p>
            Aus Schweizer Sicht ist der Euro-Franken-Kurs von grösster
            Bedeutung. Ein teurerer Franken vermindert die Wettbewerbsfähigkeit
            von Schweizer Unternehmen im Export. Das führt schnell zu
            weitreichenden Problemen: Der Binnenmarkt ist vergleichsweise klein,
            die Schweizer Wirtschaft ist stark von Exporten abhängig.{' '}
            <strong>
              Der Kurs des Euro ist im Zuge der Krise deutlich gesunken.
            </strong>{' '}
            Ein billigerer Euro steht umgekehrt für einen teureren Franken. (Um
            diesen Zusammenhang zu vereinfachen, zeigt die Grafik deshalb den
            Preis des Euro in Franken). Die Wertzunahme des Franken ist die
            Folge davon, dass die Schweizer Währung stets als sicherer Hafen in
            unsicheren Zeiten wahrgenommen wird. Dass es nicht zu einer noch
            stärkeren Aufwertung gekommen ist, liegt vor allem am Wirken der
            Schweizerischen Nationalbank, die sich mit Interventionen auf den
            Devisenmärkten (Käufen von Devisen gegen Franken zur Neutralisierung
            der Frankenkäufe) der Aufwertung entgegenstemmt.
          </p>
          <div style={{ margin: '30px 0 10px 0' }}>
            <b>Langfristige Entwicklung des Eurokurses</b>
            <AutofitIFrame src='https://datawrapper.dwcdn.net/5TJOA/' />
          </div>
          <p>
            <a href='#eur'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          {/* <div className='box'>
            <p>

              Die Publikumszahlen werden von Mediapulse in ausgewählten Testhaushalten erhoben und dann auf die gesamte Bevölkerung hochgerechnet. SRF stellt die Publikumszahlen auf der eigenen Website zur Verfügung – allerdings nur für SRF1 und SRFzwei und teilweise mit einigen Tagen Verspätung. Nach einer Woche verschwinden die Dokumente wieder. Für diese Grafik werden die Tabellen in den PDFs automatisiert ausgelesen und aufbereitet. Aus den darin aufgelisteten  durchschnittlichen Zuschauerzahl pro Sendung wird über den ganzen Tag der Mittelwert gebildet.  

            </p>
          </div> */}
        </div>
      </div>

      <div className='ui vertical segment' id='bitcoin_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Bitcoin</b>
          </h3>
          <p>
            Zuweilen haben Anhänger Bitcoin mit der Behauptung verteidigt, die
            Kryptowährung biete eine Alternative zum von Notenbanken und Staaten
            beeinflussten Geld. In einer Krise müsste der Bitcoin nach dieser
            Logik grössere Sicherheit ausstrahlen als anderes Geld oder andere
            Kapitalanlagen. Allerdings ist derzeit nichts davon zu sehen.{' '}
            <strong>
              Die Anleger scheinen in der Kryptowährung während der Corona-Krise
              vor allem eine Hochrisikoanlage zu sehen.
            </strong>{' '}
            Entsprechend hat diese Währung einmal mehr in ihrer an heftigen
            Ausschlägen reichen Geschichte deutlich an Wert verloren. Wie sich
            der Kurs im weiteren Verlauf der Corona-Krise entwickeln wird, lässt
            sich derzeit denn auch kaum abschätzen.
          </p>
          <p>
            <a href='#bitcoin'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          {/* <div className='box'>
            <p>

              Die Publikumszahlen werden von Mediapulse in ausgewählten Testhaushalten erhoben und dann auf die gesamte Bevölkerung hochgerechnet. SRF stellt die Publikumszahlen auf der eigenen Website zur Verfügung – allerdings nur für SRF1 und SRFzwei und teilweise mit einigen Tagen Verspätung. Nach einer Woche verschwinden die Dokumente wieder. Für diese Grafik werden die Tabellen in den PDFs automatisiert ausgelesen und aufbereitet. Aus den darin aufgelisteten  durchschnittlichen Zuschauerzahl pro Sendung wird über den ganzen Tag der Mittelwert gebildet.  

            </p>
          </div> */}
        </div>
      </div>

      <div className='ui vertical segment' id='gold_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Gold</b>
          </h3>
          <p>
            Historisch gesehen, war das Gold stets ein sicherer Hafen. In Krisen
            wurde das gelbe Metall besonders nachgefragt. Deshalb stieg in der
            Vergangenheit dann jeweils auch der Preis. Davon ist diesmal nicht
            viel zu sehen.{' '}
            <strong>
              Seit das Coronavirus sich in der ganzen Welt stark verbreitet, hat
              auch der Goldpreis nachgegeben.
            </strong>{' '}
            Der klassische Grund für steigende Goldpreise ist normalerweise die
            Angst vor einer Inflation – also einem Wertverlust des Geldes. Der
            aktuelle Wirtschaftseinbruch deutet aber eher auf das Gegenteil hin:
            auf ein sinkendes Preisniveau, weil die Gesamtnachfrage noch mehr
            leidet als das Gesamtangebot, also die Fähigkeit der Unternehmen,
            Güter auf den Markt zu bringen. Aus dem gleichen Grund hat das Gold
            schon während der Finanzkrise an Wert verloren. Überwiegen in
            Zukunft die Engpässe bei den Unternehmen und befeuern die
            Geldspritzen der Notenbanken und Staaten die Nachfrage, könnte sich
            das Bild allerdings ändern – und der Goldkurs würde wieder steigen.
          </p>
          <p>
            Auch mit den starken Ausschlägen im März hat der Goldpreis noch
            nicht sein Allzeithoch von 2011 erreicht. Damals haben die
            Schuldenkrise im Euroraum, die Zweifel an der US-Bonität sowie die
            Proteste im arabischen Raum den Anstieg des Goldpreises auf über
            1800 Dollar pro Feinunze begünstigt.
          </p>
          <div style={{ margin: '30px 0 10px 0' }}>
            <b>Langfristige Entwicklung des Goldpreises</b>
            <AutofitIFrame src='https://datawrapper.dwcdn.net/KTsVG/' />
          </div>
          <p>
            <a href='#gold'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          {/* <div className='box'>
            <p>
              Das Resultat ist ein Schock. Hätte man überhaupt keine
              Eindämmungsmassnahmen getroffen und das Virus einfach durch die
              nicht durch Immunität und Impfung geschützte Bevölkerung laufen
              lassen,{' '}
            </p>
          </div> */}
        </div>
      </div>

      <div className='ui vertical segment' id='oil_info'>
        <div className='ui text container infographic'>
          <h3 className='ui dividing infographic'>
            <b>Öl</b>
          </h3>
          <p>
            Der extreme Einbruch des Ölpreises ist eine Folge des
            Wirtschaftsabschwungs: Wenn wir weniger unterwegs sind und die
            Industrie weniger Güter produziert, wird weniger Öl benötigt. Die
            sinkende Nachfrage drückt auf den Preis. Doch das ist nur ein Grund
            für den Einbruch. Der andere ist die Wirtschaftspolitik der Öl
            fördernden Staaten: Weil sich Russland dem Vorstoss des Ölgiganten
            Saudiarabien nicht angeschlossen hat, die Ölfördermenge zu
            reduzieren, haben die Saudis als Vergeltung die Fördermenge erst
            recht hochgefahren – zum Schaden Russlands, aber auch weiterer Erdöl
            produzierender Länder.
          </p>
          <div style={{ margin: '30px 0 10px 0' }}>
            <b>Langfristige Entwicklung des Ölpreises</b>
            <AutofitIFrame src='https://datawrapper.dwcdn.net/hxu9i/' />
          </div>
          <p>
            <a href='#oil'>
              <i className='arrow alternate up icon' /> zurück zur Grafik
            </a>
          </p>
          {/* <div className='box'>
            <p>
              Das Resultat ist ein Schock. Hätte man überhaupt keine
              Eindämmungsmassnahmen getroffen und das Virus einfach durch die
              nicht durch Immunität und Impfung geschützte Bevölkerung laufen
              lassen,{' '}
            </p>
          </div>
          */}
        </div>
      </div>

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        credits={[
          ['Konzept, Recherche', 'Patrick Meier, Sven Cornehls'],
          [
            'Umsetzung',
            'Mathias Born, Sven Cornehls, Markus Diem, Simone Luchetta, Patrick Meier'
          ]
        ]}
      />
    </div>
  )
}
